module.exports = __webpack_public_path__ + "img/icn-android.502ecdd2.svg";